/* ONNO — shared scroll reveal for [data-onno-reveal] elements.
   Loaded once via snippets/onno-fonts.liquid. Safe to include multiple times. */
(function () {
  'use strict';
  if (window.__onnoRevealInit) return;
  window.__onnoRevealInit = true;

  function init() {
    var items = document.querySelectorAll('[data-onno-reveal]:not(.is-inview)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-onno-reveal') || 0;
          entry.target.style.transitionDelay = delay + 'ms';
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init); // theme editor support
})();
